import css from './../../css/form';

export default {
    methods: {
        getLabel()
        {
            if ( ! this.displayLabel ) {
                return '';
            }

            if ( this.label ) {
                return this.label;
            }

            if ( this.$t('form.labels.' + this.inputName) == 'form.labels.' + this.inputName ) {
                return this.inputName.slugToLabel();
            }
            return this.$t('form.labels.' + this.inputName);
        },
        
        getPlaceholder()
        {
            if ( this.placeholder ) {
                return this.placeholder;
            }

            if ( this.$t('form.placeholders.' + this.inputName) == 'form.placeholders.' + this.inputName ) {
                return this.inputName.slugToLabel();
            }
            return this.$t('form.placeholders.' + this.inputName);
        },

        getModel()
        {
            if ( this.customValue ) {
                return this.customValue;
            }
            
            if ( this.inputIsArray && this.inputKey !== null ) {
                return this.form[this.inputName][this.inputKey];
            }
            return this.form[this.inputName];
        },

        setModel(value)
        {
            this.$emit('updated', value);
            if ( this.inputIsArray && this.inputKey !== null ) {
                return this.form[this.inputName][this.inputKey] = value;
            }
            return this.form[this.inputName] = value;
        }
    },
    props: {
        form: {
            type: Object,
            required: true
        },
        inputName: {
            type: String,
            required: true
        },
        inputIsArray: {
            type: Boolean,
            default: false
        },
        inputKey: {
            default: ''
        },
        type: {
            type: String,
            default: 'text'
        },
        id: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default() {
                return null;
            }
        },
        displayLabel: {
            type: Boolean,
            default: true
        },
        displayError: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default() {
                return null;
            }
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        className: {
            type: String,
            default() {
                return css.input;
            }
        },
        withCounter: {
            type: Boolean,
            default: false
        },
        maxLength: {
            type: Number,
            default: null
        },
        containerClassName: {
            type: String,
            default() {
                return css.containers.element;
            }
        },
        labelClassName: {
            type: String,
            default: null
        },
        labelContainerClassName: {
            type: String,
            default() {
                return css.containers.label;
            }
        },
        inputContainerClassName: {
            type: String,
            default() {
                return css.containers.input;
            }
        },
        helper: {
            type: String,
            default: null
        },
        customValue: {
            type: String,
            default: null
        }
    },
    computed: {
        model: {
            get() {
                return this.getModel();
            },
            set(value) {
                return this.setModel(value);
            }
        }
    }
}